<template>
  <div class="message-multiple-attachments"
       ref="messageMultupleAttachments">
    <div class="message-multiple-attachments__items">
      <message-multiple-attachments-item v-for="attachment in message.attachments"
                                         :key="attachment.uploadid"
                                         :attachment="attachment"
                                         @attachment-loaded="attachmentLoaded"/>
    </div>
    <p class="Label1 gray-400">{{ formattedTime }}</p>
  </div>
</template>

<script>
  import MessageMultipleAttachmentsItem from "@/components/messages/message-multiple-attachments-item";
  import {toPhilMoment} from '@/utils/dates';
  import MsgInitialVisibleChecker from '@/mixins/msg-initial-visible-checker-mixin';

  export default {
    name: "message-multiple-attachments",
    components: {MessageMultipleAttachmentsItem},
    mixins: [MsgInitialVisibleChecker],
    props: {
      message: {type: Object, required: true}
    },
    computed: {
      formattedTime() {
        return toPhilMoment(this.message.date).format('hh:mm a');
      },
    },
    mounted() {
      this.observeMsgEl(this.$refs.messageMultupleAttachments);
    },
    methods: {
      attachmentLoaded() {
        if (this.isMsgInitialVisible) {
          this.$emit('loaded');
        }
      },
    }
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .message-multiple-attachments {
    position: relative;
    overflow: hidden;
    border-radius: radius(medium);
    padding: space(s) space(m);
    background-color: color(gray-50);
  }

  .message-multiple-attachments__items {
    @extend %layout--flex-row;
    @include responsive('max-width: 500px') {
      flex-direction: column;
      flex-wrap: nowrap;
    }

    flex-wrap: wrap;
  }
</style>